export var DataExportJobState;
(function (DataExportJobState) {
    DataExportJobState["Active"] = "ACTIVE";
    DataExportJobState["Completed"] = "COMPLETED";
    DataExportJobState["Computing"] = "COMPUTING";
    DataExportJobState["Deleted"] = "DELETED";
    DataExportJobState["Suspended"] = "SUSPENDED";
    DataExportJobState["Invalid"] = "INVALID";
})(DataExportJobState || (DataExportJobState = {}));
export var DataExportJobStateTransition;
(function (DataExportJobStateTransition) {
    DataExportJobStateTransition["Resume"] = "resume";
    DataExportJobStateTransition["Suspend"] = "suspend";
    DataExportJobStateTransition["Delete"] = "delete";
    DataExportJobStateTransition["Invalid"] = "Invalid";
})(DataExportJobStateTransition || (DataExportJobStateTransition = {}));
//# sourceMappingURL=data-export.job-state.js.map